<template>
  <div class="present">
    <div class="present__animation" ref="animationContainer"></div>
    <div class="present__panel">
      <div class="panel">
        <div class="panel__inner">
          <img :src="`${staticPath}img/factory/test/${filename}`">
        </div>
      </div>
    </div>
    <div class="present__return">
      <div v-on:click="onReturn()" class="modal-box__return">
        <img :src="`${staticPath}img/factory/btn_return.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/modules.scss';

.present {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  max-width: $max-page-width;
  min-width: 320px;
  max-height: $max-page-height;
  min-height: 500px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.present__animation {
  position: absolute;
  z-index: 201;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.present__panel {
  position: absolute;
  z-index: 200;
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px;
  overflow: hidden;
}

.present__return {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 88px;
  height: 43px;
}

.panel {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width:100%;
  height: 100%;
}

.panel__inner {
  width: 340px;
  height: 440px;
}

</style>

<script>
  import Constant from '@/constant';
  import lottie from 'lottie-web';

  export default {
    name: 'Present',
    props: ['testType', 'testId'],

    data(){
      return {
        staticPath: Constant.STATICPATH,
        animationFile: 'data.json'
      }
    },

    mounted() {
      this.anim = lottie.loadAnimation({
          container: this.$refs.animationContainer,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          prerender: true,
          path: this.staticPath + 'lottie/present/' + this.animationFile
        }
      );
    },

    computed: {

      filename(){
        return 'pnl_present_' + this.testType + '_' + this.testId + '.png';
      }
    },

    methods: {

      onReturn() {
        this.$emit('goto-factory');
      }
    },

    beforeDestroy () {
      this.anim.destroy();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/Parts/Present.vue